'use strict';

var React = require('react');

var SvgColorNoneMinor = function SvgColorNoneMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.759 4.35a1 1 0 0 0-1.41-.108s-14.036 12.032-14.055 12.05a1 1 0 0 0 0 1.415.992.992 0 0 0 1.35.043l.008.01 1.963-1.683a5.97 5.97 0 0 0 4.385 1.923 6 6 0 0 0 6-6c0-1.157-.51-2.48-1.223-3.777l2.873-2.463a.999.999 0 0 0 .108-1.41zm-13.75 7.834c-.002-.062-.01-.121-.01-.184 0-4 6-10 6-10s1.2 1.203 2.526 2.885l-8.516 7.299z"
  }));
};

exports.SvgColorNoneMinor = SvgColorNoneMinor;
